module.exports = __webpack_public_path__ + "static/media/UserTask.9c61c507.svg";